function viability(v) {
  if (v === 0 || v === undefined) return "0%";
  return v.toPrecision(3) + "%";
}
export default viability;
